import React from "react";
import { VStack, Flex, Box } from "@chakra-ui/react";
import {
  StepsRoot,
  StepsList,
  StepsItem,
  StepsNextTrigger,
  StepsPrevTrigger,
} from "../ui/steps";
import CustomButton from "./CustomButton";
import useThemeColors from "../../hooks/useThemeColors";
import Cad from "./Cad";

interface Step {
  title: string;
}

interface CustomStepProps {
  steps: Step[];
  currentStep: number;
  onStepChange: (step: number) => void;
  children: React.ReactNode;
  isNextDisabled?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
  hideNextButtonOnFinalStep?: boolean;
}

const CustomStep: React.FC<CustomStepProps> = ({
  steps,
  currentStep,
  onStepChange,
  children,
  isNextDisabled = false,
  size = "md",
  hideNextButtonOnFinalStep = true,
}) => {
  const colors = useThemeColors();

  return (
    <StepsRoot
      w="full"
      colorPalette={colors.schoolAccent.primary}
      step={currentStep}
      onStepChange={({ step }) => onStepChange(step)}
      count={steps.length}
      size={size}
    >
      <VStack gap={[2, 4]} overflow={"hidden"} align={"start"} w="full">
        <Cad h="auto">
          <StepsList maxW={{ base: "full", lg: "600px" }}>
            {steps.map((step, index) => (
              <StepsItem key={index} index={index} title={step.title} />
            ))}
          </StepsList>
        </Cad>

        <Box flex={1} minH={0} w={"full"}>
          {children}
        </Box>

        <Flex justify="space-between" w="full">
          <StepsPrevTrigger asChild>
            <CustomButton
              variant="ghost"
              colorPalette={colors.schoolAccent.primary}
              label="Back"
              size="sm"
            />
          </StepsPrevTrigger>

          {(!hideNextButtonOnFinalStep || currentStep < steps.length - 1) && (
            <StepsNextTrigger asChild disabled={isNextDisabled}>
              <CustomButton
                colorPalette={colors.schoolAccent.primary}
                label="Next"
                size="sm"
              />
            </StepsNextTrigger>
          )}
        </Flex>
      </VStack>
    </StepsRoot>
  );
};

export default CustomStep;
